<div class="pulse-strip pulse-strip--light" [attr.aria-label]="ariaLabel">
  <div class="pulse-label">
    <span class="pulse-dot" aria-hidden="true"></span>
    {{ label }}
  </div>
  <div class="pulse-track">
    <div class="pulse-marquee">
      <ng-container *ngFor="let item of doubledItems; let i = index; let last = last">
        <span class="item"><span class="when">{{ item.when }}</span> {{ item.text }}</span>
        <span class="sep" *ngIf="!last">&middot;</span>
      </ng-container>
    </div>
  </div>
</div>
